import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box } from "@mui/material";
import styles from "../styles/showPayment.module.scss";
import { DataGrid, esES } from "@mui/x-data-grid";
import { contentTableRowProvision } from "../helpers";
import { useShowProvisionHistory } from "../hooks/useShowProvisionHistory";
import "../styles/_tableDetaildConsultation.scss";

export const ShowProvisionHistory = () => {
  const {
    activeProvisions,
    dataProvisions,
    hasError,
    isLoading,
    handleActiveProvisions,
  } = useShowProvisionHistory();

  return (
    <div
      style={{ display: "inline-flex" }}
      onMouseEnter={() => handleActiveProvisions(true)}
      onMouseLeave={() => handleActiveProvisions(false)}
    >
      <VisibilityIcon
        className={styles.editView}
        data-testid="btn-provision-history"
        style={{ cursor: "pointer" }}
      />
      {activeProvisions && (
        <Box
          className={styles.modalInputAutorization}
          data-testid="container-provision-history"
          sx={{ maxWidth: "850px" }}
        >
          {isLoading ? (
            <Box role="status" sx={{ p: 2 }}>
              Consultando provisiones exitosas...
            </Box>
          ) : hasError ? (
            <Box role="alert" sx={{ p: 2 }}>
              No fue posible consultar las provisiones. Intente nuevamente.
            </Box>
          ) : dataProvisions.length > 0 ? (
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
              gap={"8px"}
            >
              <Box className="" padding={0} border={0}>
                <DataGrid
                  rows={dataProvisions}
                  columns={contentTableRowProvision}
                  className={`${styles.tableResults} tableAuthorizationPayments`}
                  data-testid="datagrid-provision"
                  disableColumnFilter
                  disableColumnSelector
                  disableDensitySelector
                  disableColumnMenu={true}
                  hideFooterSelectedRowCount={true}
                  hideFooterPagination={true}
                  hideFooter={true}
                  localeText={
                    esES.components.MuiDataGrid.defaultProps.localeText
                  }
                />
              </Box>
            </Box>
          ) : (
            <Box role="status" sx={{ p: 2 }}>
              No hay provisiones exitosas para esta factura.
            </Box>
          )}
        </Box>
      )}
    </div>
  );
};
